import React, { Fragment } from "react";
import { useCategory } from "../../../Pregrine/RootComponents/Category/useCategory";
import ErrorView from "../../ErrorView/ErrorView";
import CategoryContent from "./categoryContent";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const Category = () => {
  const {
    id,
    categoryName,
    error,
    loading,
    categoryData,
    metaTitle,
    metaDescription,
    pageNumberParam,
    sortProps,
    pageSize,
    setFilters,
    filters,
    initialFilter,
    MegaMenuData,
    megaMenuLoading,
    searchInput,
    setSearchInput,
    handleInputChange,
    loadingState,
  } = useCategory();

  const location = useLocation();
  const currentPath = location.pathname;

  if (!categoryData && error && pageNumberParam === 1) {
    if (process.env.NODE_ENV !== "production") {
      console.error(error);
    }
    return <ErrorView />;
  }

  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link
          rel="canonical"
          href={`${window.location.origin}${currentPath}`}
        />
      </Helmet>
      <CategoryContent
        categoryId={id}
        data={categoryData}
        isLoading={loading}
        pageNumberParam={pageNumberParam}
        sortProps={sortProps}
        pageSize={pageSize}
        loadingState={loadingState}
        setFilters={setFilters}
        filters={filters}
        initialFilter={initialFilter}
        categorySidebarData={MegaMenuData}
        megaMenuLoading={megaMenuLoading}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        handleInputChange={handleInputChange}
        categoryName={categoryName}
      />
    </Fragment>
  );
};

export default React.memo(Category);
